export default __webpack_public_path__ + "static/media/treatment-logo-ortho-whitening.3227038f.png";